import { render, staticRenderFns } from "./ApplicationSelector.vue?vue&type=template&id=b63553e6"
import script from "./ApplicationSelector.vue?vue&type=script&lang=js"
export * from "./ApplicationSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports